import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseUs = ({ onExploreSuccess }) => {
  return (
    <section id="why-us" className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        
        {/* Main Grid Layout */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          
          {/* --- LEFT SIDE: Marketing Message --- */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1 text-center lg:text-left">
            <motion.h2 
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-red-600 font-bold tracking-widest uppercase text-xs md:text-sm mb-3"
            >
              Vidulaka Success Story
            </motion.h2>
            
            <motion.h3 
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-3xl sm:text-4xl md:text-6xl font-black text-indigo-950 mb-6 leading-tight"
            >
              Home to the <br/> 
              <span className="text-red-600">Island's Top 100</span> <br/> 
              Rankers
            </motion.h3>
            
            <div className="space-y-6 text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              <p>
                Every year, a vast majority of students who secure places within the **Island’s Top 100** choose Vidulaka Matale as their guiding light.
              </p>
              <div className="border-l-4 border-yellow-400 pl-4 italic bg-indigo-50/50 py-4 rounded-r-xl text-left">
                "Our consistent track record in O/L and A/L results proves our commitment to academic brilliance."
              </div>
            </div>

            {/* --- THE BUTTON --- */}
            <div className="mt-8 md:mt-10 flex justify-center lg:justify-start">
                <button 
                  onClick={onExploreSuccess} // App.js eke function eka trigger wei
                  className="bg-indigo-950 text-white px-8 md:px-10 py-3.5 md:py-4 rounded-2xl font-bold hover:bg-red-600 transition-all shadow-xl flex items-center group w-full sm:w-auto justify-center active:scale-95"
                >
                    Explore Success Stories
                    <svg className="w-5 h-5 ml-3 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </button>
            </div>
          </div>

          {/* --- RIGHT SIDE: Highlight Image --- */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2 relative">
            {/* Decorative backgrounds */}
            <div className="absolute -top-6 -right-6 w-24 md:w-32 h-24 md:h-32 bg-yellow-400 rounded-full -z-10 opacity-20 blur-2xl animate-pulse"></div>
            
            <div className="relative rounded-[2rem] md:rounded-[3rem] overflow-hidden shadow-2xl border-4 md:border-8 border-white">
                <img 
                  src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=800&auto=format&fit=crop" 
                  alt="Vidulaka Students" 
                  className="w-full h-[300px] sm:h-[400px] md:h-[500px] object-cover hover:scale-105 transition-transform duration-700"
                />
                
                {/* Floating Badge */}
                <div className="absolute top-4 left-4 md:top-8 md:left-8 bg-indigo-950/90 text-white p-4 md:p-6 rounded-2xl shadow-2xl backdrop-blur-md">
                    <p className="text-yellow-400 font-black text-2xl md:text-4xl leading-none">50+</p>
                    <p className="text-[8px] md:text-[10px] font-bold uppercase tracking-widest mt-1">Island Top 100<br/>Ranks Yearly</p>
                </div>
            </div>

            {/* Success Card - Visible on Desktop/Tablet */}
            <div className="absolute -bottom-4 -right-2 bg-white p-4 md:p-5 rounded-2xl shadow-2xl border border-gray-100 hidden sm:block">
                <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 text-lg font-bold">✓</div>
                    <div>
                        <p className="text-indigo-950 font-black text-xs md:text-base leading-none">100% Pass Rate</p>
                    </div>
                </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;